module.exports = __webpack_public_path__ + "img/3d-example.99b5e46f.png";